import { isUsingFakeData } from '@/components/shared/DevPanel/DevPanel.helpers';
import { ClarityEvent } from './types';
import { configBase } from '@/config/base';

type ClarityWindowKey = 'clarityEvents' | 'clarityDebugEvents';

export const trackClarity = (event: ClarityEvent) => {
    if (!configBase.tracking.enabled || isUsingFakeData()) {
        trackWindowEvent('clarityDebugEvents', event);
        return;
    }

    if (window.clarity) {
        window.clarity('event', event);
        trackWindowEvent('clarityEvents', event);
    } else {
        console.warn('[Clarity] window.clarity not found');
    }
};

const trackWindowEvent = (key: ClarityWindowKey, event: ClarityEvent): void => {
    window[key] = window[key] || [];
    window[key]!.push(event);
};
